var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program-preview flex-b-c"},[_c('div',{staticClass:"w-list"},[_c('window-list')],1),_c('div',{staticClass:"vdr-box flex-c-c",attrs:{"id":"programPreview"}},[_c('vdr')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }